import React from 'react';

import { DONE, PENDING } from 'src/utils/constants';
import BaseChip from './base-chip';

const colorDict = {
  [DONE]: 'darkGreen',
  [PENDING]: 'blue',
};

const BankReconciliationStatusChip = ({ status }) => {
  const key = (status && status.id) || status;
  const value = (status && status.name) || status;
  if (!value) return null;
  return <BaseChip color={colorDict[key]} label={value} />;
};

export default BankReconciliationStatusChip;
